export const state = () => ({
  photoList: [],
});

export const getters = {
  formData(state) {
    const photos = JSON.parse(JSON.stringify(state.photoList));
    let data;
    if (Object.keys(photos).length > 0) {
      const uuids = photos.map(function (photo) {
        return photo.uuid;
      });

      const primaryPhoto = photos.find(function (photo) {
        return photo.isPrimary;
      });
      data = {
        primary_photo_uuid: primaryPhoto ? primaryPhoto.uuid : null,
        photo_uuids: uuids,
      };
    } else {
      data = {
        photo_uuids: [],
        primary_photo_uuid: null,
      };
    }
    return data;
  },
};

export const mutations = {
  SET_PHOTO_LIST(state, payload) {
    state.photoList = payload;
  },
  ADD_PHOTO(state, payload) {
    state.photoList.push(payload);
  },
  UPDATE_PHOTO(state, payload) {
    const photo = state.photoList.find((item) => item.localId === payload.localId);
    if (photo) Object.assign(photo, payload.changes);
  },
  REMOVE_PHOTO(state, arrIndex) {
    const photo = state.photoList[arrIndex];
    if (
      photo &&
      photo.src &&
      photo.src.indexOf('blob:') === 0 &&
      typeof window !== 'undefined' &&
      window.URL
    ) {
      window.URL.revokeObjectURL(photo.src);
    }
    state.photoList.splice(arrIndex, 1);
  },
  TOGGLE_PRIMARY_PHOTO(state, arrIndex) {
    let photo = state.photoList[arrIndex];
    if (photo.isPrimary) {
      photo.isPrimary = false;
      state.photoList[arrIndex] = photo;
    } else {
      state.photoList = state.photoList.map(function (element, index) {
        element.isPrimary = index == arrIndex;
        return element;
      });
    }
  },
  ADD_PHOTOS(state, photos) {
    photos.forEach(function (photo) {
      if (photo) {
        state.photoList.push({
          localId: photo.uuid,
          fileName: photo.uuid,
          isPrimary: photo.is_primary_photo,
          src: photo.photo_image,
          uuid: photo.uuid,
          uploadStatus: 'uploaded',
        });
      }
    });
  },
};
export const actions = {
  restoreInitialState({ commit }) {
    commit('SET_PHOTO_LIST', []);
  },
  applyEditData({ commit }, { data }) {
    if (data.photo_data.listing_photos) {
      if (data.photo_data.listing_photos.length > 0) {
        commit('ADD_PHOTOS', data.photo_data.listing_photos);
      }
    }
  },
};
